import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-no-margin]': 'hasNoMargin',
    '[class]': 'variant',
  },
})
export class DividerComponent {
  public static readonly VARIANTS: Variants = [
    'line',
    ['line', 'medium', 'default', 'large', 'dot', 'transparent', 'dark', 'square', 'color-border'],
  ];
  @ComponentVariant(DividerComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public hasNoMargin: boolean = false;
}
